export const initialValues = {
    boost: 0.8,
    appleSub: 5,
    youTube: 0.10,
    boostPro: 2,
    newsletter: 0.6,
    audio: 25,
};
